<template>
    <templatesite>
        <template v-slot:appheader>
            <appheader></appheader>
        </template>

        <template v-slot:appsidebar>
            <appsidebar></appsidebar>
        </template>

        <template v-slot:appcontent>
            <div class="content" style="margin-top: 0">
                <div class="main-content">

                    <!-- En-tête de page -->
                    <div class="ds-page-head">
                        <div>
                            <h1 class="ds-page-head__title">
                                <i class="ri-shield-keyhole-line"></i> Modification de mot de passe
                            </h1>
                            <p class="ds-page-head__sub">
                                Mettez à jour votre mot de passe pour renforcer la sécurité de votre compte
                            </p>
                        </div>
                        <div class="cf-tool-grp">
                            <span class="cf-chip cf-chip--ok"><i class="ri-shield-check-line"></i>&nbsp;Sécurité</span>
                        </div>
                    </div>

                    <div class="mdp-container">

                        <!-- Conseils de sécurité -->
                        <div class="cf-note cf-note--info mdp-tips">
                            <i class="ri-information-fill"></i>
                            <div>
                                <h3 class="mdp-tips__title">Conseils de sécurité</h3>
                                <ul class="mdp-tips__list">
                                    <li>
                                        <i class="ri-check-line"></i>
                                        Utilisez au moins 8 caractères avec des lettres majuscules, minuscules, chiffres et symboles
                                    </li>
                                    <li>
                                        <i class="ri-check-line"></i>
                                        Évitez les mots de passe faciles à deviner (date de naissance, "123456", etc.)
                                    </li>
                                    <li>
                                        <i class="ri-check-line"></i>
                                        Ne réutilisez pas d'anciens mots de passe
                                    </li>
                                </ul>
                            </div>
                        </div>

                        <!-- Password Change Form -->
                        <div class="cf-card mdp-card">
                            <!-- Success Message -->
                            <div v-if="messagesucces" class="cf-note mdp-note-ok mdp-msg">
                                <i class="ri-checkbox-circle-fill"></i>
                                <p class="mdp-msg__txt">{{ messagesucces }}</p>
                            </div>

                            <!-- Error Message -->
                            <div v-if="messageerror" class="cf-note cf-note--danger mdp-msg">
                                <i class="ri-error-warning-fill"></i>
                                <p class="mdp-msg__txt">{{ messageerror }}</p>
                            </div>

                            <!-- Form -->
                            <div class="mdp-form">
                                <!-- New Password Field -->
                                <div>
                                    <label class="fa2-label"><span class="fa2-req">*</span> Nouveau mot de passe</label>
                                    <div class="relative">
                                        <i class="ri-lock-password-line fa2-field-icon"></i>
                                        <input
                                                v-model="Items.newmdp"
                                                :type="showNewPassword ? 'text' : 'password'"
                                                :class="['fa2-inp pl-9 mdp-inp', validationErrors.newmdp ? 'fa2-inp--error' : '']"
                                                placeholder="Saisissez votre nouveau mot de passe"
                                                @input="validateNewPassword"
                                                @blur="validateNewPassword"
                                        />
                                        <button
                                                @click="togglePasswordVisibility('new')"
                                                type="button"
                                                class="mdp-eye"
                                        >
                                            <i :class="showNewPassword ? 'ri-eye-off-line' : 'ri-eye-line'"></i>
                                        </button>
                                    </div>

                                    <!-- Password Strength Meter -->
                                    <div v-if="Items.newmdp" class="mdp-meter">
                                        <div class="mdp-meter__head">
                                            <span class="mdp-meter__label">Force du mot de passe :</span>
                                            <span class="mdp-meter__value" :class="passwordStrength.class">
                                                {{ passwordStrength.label }}
                                            </span>
                                        </div>
                                        <div class="mdp-meter__track">
                                            <div
                                                    class="mdp-meter__bar"
                                                    :class="passwordStrength.barClass"
                                                    :style="{ width: passwordStrength.percentage + '%' }"
                                            ></div>
                                        </div>
                                        <div class="mdp-req-grid">
                                            <div class="mdp-req">
                                                <i :class="passwordRequirements.length ? 'ri-checkbox-circle-fill mdp-ok' : 'ri-checkbox-blank-circle-line mdp-off'"></i>
                                                Au moins 8 caractères
                                            </div>
                                            <div class="mdp-req">
                                                <i :class="passwordRequirements.uppercase ? 'ri-checkbox-circle-fill mdp-ok' : 'ri-checkbox-blank-circle-line mdp-off'"></i>
                                                Lettre majuscule
                                            </div>
                                            <div class="mdp-req">
                                                <i :class="passwordRequirements.lowercase ? 'ri-checkbox-circle-fill mdp-ok' : 'ri-checkbox-blank-circle-line mdp-off'"></i>
                                                Lettre minuscule
                                            </div>
                                            <div class="mdp-req">
                                                <i :class="passwordRequirements.number ? 'ri-checkbox-circle-fill mdp-ok' : 'ri-checkbox-blank-circle-line mdp-off'"></i>
                                                Chiffre
                                            </div>
                                            <div class="mdp-req mdp-req--wide">
                                                <i :class="passwordRequirements.special ? 'ri-checkbox-circle-fill mdp-ok' : 'ri-checkbox-blank-circle-line mdp-off'"></i>
                                                Caractère spécial (!@#$%^&amp;*)
                                            </div>
                                        </div>
                                    </div>

                                    <p v-if="validationErrors.newmdp" class="fa2-err">
                                        <i class="ri-error-warning-line"></i> {{ validationErrors.newmdp }}
                                    </p>
                                </div>

                                <!-- Confirm Password Field -->
                                <div>
                                    <label class="fa2-label"><span class="fa2-req">*</span> Confirmer le mot de passe</label>
                                    <div class="relative">
                                        <i class="ri-lock-password-line fa2-field-icon"></i>
                                        <input
                                                v-model="Items.cfdp"
                                                :type="showConfirmPassword ? 'text' : 'password'"
                                                :class="['fa2-inp pl-9 mdp-inp', validationErrors.cfdp ? 'fa2-inp--error' : '']"
                                                placeholder="Confirmez votre nouveau mot de passe"
                                                @input="validateConfirmPassword"
                                                @blur="validateConfirmPassword"
                                        />
                                        <button
                                                @click="togglePasswordVisibility('confirm')"
                                                type="button"
                                                class="mdp-eye"
                                        >
                                            <i :class="showConfirmPassword ? 'ri-eye-off-line' : 'ri-eye-line'"></i>
                                        </button>
                                    </div>

                                    <!-- Match Indicator -->
                                    <div v-if="Items.cfdp" class="mdp-match">
                                        <i :class="Items.newmdp === Items.cfdp ? 'ri-checkbox-circle-fill mdp-ok' : 'ri-close-circle-fill mdp-ko'"></i>
                                        <span :class="Items.newmdp === Items.cfdp ? 'mdp-ok' : 'mdp-ko'">
                                            {{ Items.newmdp === Items.cfdp ? 'Les mots de passe correspondent' : 'Les mots de passe ne correspondent pas' }}
                                        </span>
                                    </div>

                                    <p v-if="validationErrors.cfdp" class="fa2-err">
                                        <i class="ri-error-warning-line"></i> {{ validationErrors.cfdp }}
                                    </p>
                                </div>

                                <!-- Form Actions -->
                                <div class="mdp-actions">
                                    <button
                                            @click="modifiermotdepasse"
                                            :disabled="isSubmitting || !isFormValid"
                                            class="ti-btn ti-btn-primary-full !font-medium !text-[0.85rem] mdp-submit"
                                    >
                                        <svg v-if="isSubmitting" class="animate-spin mdp-spin" fill="none" viewBox="0 0 24 24">
                                            <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
                                            <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                                        </svg>
                                        <i v-else class="ri-save-3-line"></i>
                                        {{ isSubmitting ? 'Modification en cours...' : 'Modifier le mot de passe' }}
                                    </button>

                                    <button
                                            @click="resetForm"
                                            type="button"
                                            class="ds-btn-ghost"
                                    >
                                        <i class="ri-refresh-line"></i> Réinitialiser
                                    </button>
                                </div>
                            </div>
                        </div>

                        <!-- Additional Information -->
                        <div class="mdp-info-grid">
                            <div class="cf-card cf-card--piece">
                                <h3 class="cf-card__title"><i class="ri-shield-check-line"></i> Sécurité renforcée</h3>
                                <p class="mdp-info__txt">
                                    Après la modification, vous serez déconnecté et devrez vous reconnecter avec votre nouveau mot de passe pour des raisons de sécurité.
                                </p>
                            </div>

                            <div class="cf-card cf-card--piece">
                                <h3 class="cf-card__title"><i class="ri-time-line"></i> Fréquence de changement</h3>
                                <p class="mdp-info__txt">
                                    Il est recommandé de changer votre mot de passe tous les 90 jours pour maintenir un niveau de sécurité optimal.
                                </p>
                            </div>
                        </div>
                    </div>

                </div>
            </div>
        </template>
    </templatesite>
</template>

<script>
    import templatesite from "@/components/template/apptemplate";
    import appheader from "@/components/template/appheader";
    import appsidebar from "@/components/template/appsidebar";
    import * as JwtService from "@/common/jwt.service";
    import { randomString } from "@/allfunction";
    const axios = require('axios');

    export default {
        /* eslint-disable */
        name: "PasswordChange",

        components: {
            templatesite,
            appheader,
            appsidebar,
        },

        data() {
            return {
                Items: {
                    newmdp: '',
                    cfdp: ''
                },
                messagesucces: "",
                messageerror: "",
                isSubmitting: false,
                showNewPassword: false,
                showConfirmPassword: false,
                validationErrors: {
                    newmdp: "",
                    cfdp: ""
                },
                passwordRequirements: {
                    length: false,
                    uppercase: false,
                    lowercase: false,
                    number: false,
                    special: false
                }
            };
        },

        computed: {
            isFormValid() {
                return (
                    this.Items.newmdp &&
                    this.Items.cfdp &&
                    this.Items.newmdp === this.Items.cfdp &&
                    this.passwordStrength.score >= 3 &&
                    !this.validationErrors.newmdp &&
                    !this.validationErrors.cfdp
                );
            },

            passwordStrength() {
                let score = 0;

                // Check requirements
                const hasLength = this.Items.newmdp.length >= 8;
                const hasUppercase = /[A-Z]/.test(this.Items.newmdp);
                const hasLowercase = /[a-z]/.test(this.Items.newmdp);
                const hasNumber = /\d/.test(this.Items.newmdp);
                const hasSpecial = /[!@#$%^&*]/.test(this.Items.newmdp);

                // Calculate score
                if (hasLength) score++;
                if (hasUppercase) score++;
                if (hasLowercase) score++;
                if (hasNumber) score++;
                if (hasSpecial) score++;

                // Update requirements
                this.passwordRequirements = {
                    length: hasLength,
                    uppercase: hasUppercase,
                    lowercase: hasLowercase,
                    number: hasNumber,
                    special: hasSpecial
                };

                // Determine strength level
                const percentage = (score / 5) * 100;

                if (score <= 1) {
                    return {
                        score,
                        percentage,
                        label: "Très faible",
                        class: "text-red-600 dark:text-red-400",
                        barClass: "bg-red-500"
                    };
                } else if (score <= 2) {
                    return {
                        score,
                        percentage,
                        label: "Faible",
                        class: "text-orange-600 dark:text-orange-400",
                        barClass: "bg-orange-500"
                    };
                } else if (score <= 3) {
                    return {
                        score,
                        percentage,
                        label: "Moyen",
                        class: "text-yellow-600 dark:text-yellow-400",
                        barClass: "bg-yellow-500"
                    };
                } else if (score <= 4) {
                    return {
                        score,
                        percentage,
                        label: "Fort",
                        class: "text-green-600 dark:text-green-400",
                        barClass: "bg-green-500"
                    };
                } else {
                    return {
                        score,
                        percentage,
                        label: "Très fort",
                        class: "text-green-700 dark:text-green-300",
                        barClass: "bg-green-600"
                    };
                }
            }
        },

        methods: {
            togglePasswordVisibility(type) {
                if (type === 'new') {
                    this.showNewPassword = !this.showNewPassword;
                } else {
                    this.showConfirmPassword = !this.showConfirmPassword;
                }
            },

            validateNewPassword() {
                if (!this.Items.newmdp) {
                    this.validationErrors.newmdp = "Le nouveau mot de passe est requis";
                    return;
                }

                if (this.Items.newmdp.length < 8) {
                    this.validationErrors.newmdp = "Le mot de passe doit contenir au moins 8 caractères";
                    return;
                }

                this.validationErrors.newmdp = "";
            },

            validateConfirmPassword() {
                if (!this.Items.cfdp) {
                    this.validationErrors.cfdp = "La confirmation du mot de passe est requise";
                    return;
                }

                if (this.Items.newmdp !== this.Items.cfdp) {
                    this.validationErrors.cfdp = "Les mots de passe ne correspondent pas";
                    return;
                }

                this.validationErrors.cfdp = "";
            },

            resetForm() {
                this.Items = {
                    newmdp: '',
                    cfdp: ''
                };
                this.messagesucces = "";
                this.messageerror = "";
                this.validationErrors = {
                    newmdp: "",
                    cfdp: ""
                };
                this.showNewPassword = false;
                this.showConfirmPassword = false;
            },

            async modifiermotdepasse() {
                // Validate form
                this.validateNewPassword();
                this.validateConfirmPassword();

                if (this.validationErrors.newmdp || this.validationErrors.cfdp) {

                    toastr['error']( "Veuillez corriger les erreurs dans le formulaire","<b></b>");
                    return;
                }

                if (!this.isFormValid) {

                    toastr['error']( "Le mot de passe ne répond pas aux exigences de sécurité","<b></b>");
                    return;
                }

                this.$store.dispatch('lancerchargement',true)

                this.isSubmitting = true;
                this.messageerror = "";
                this.messagesucces = "";

                const t = this;
                let url = `${process.env.VUE_APP_API_URL}/login1478pojhgfderffg458755/password/${this.$store.state.appsociete}/${randomString()}`;

                try {
                    const response = await axios.post(url, this.Items, {
                        headers: {
                            'X-Requested-With': 'XMLHttpRequest',
                            'Accept': 'application/json',
                            'Content-Type': 'application/json',
                            'Authorization': 'Bearer ' + JwtService.getToken(),
                            'csrftoken': this.$store.state.appsociete
                        },
                        withCredentials: true
                    });

                    if (response.data.success) {
                        this.messagesucces = "Mot de passe modifié avec succès ! Redirection...";
                        toastr['success']( "Mot de passe modifié avec succès. Vous allez être redirigé...","<b></b>");
                        // Clear tokens and user data
                        JwtService.setAuthorization("");
                        t.$store.commit('userdata', { value: [] });
                        t.$store.commit('isAuthenticated', { value: false });
                        t.$store.commit('beartoken', { value: "" });

                        JwtService.unsetTokenSociete();
                        JwtService.unsetToken();
                        JwtService.unsetTokenID();
                        JwtService.unsetTokenEXPIRESIN();



                        window.location.reload();

                    } else {
                        this.handleErrorResponse(response.data);
                    }
                } catch (error) {
                    console.error('Error changing password:', error);
                    this.messageerror = "Une erreur est survenue. Veuillez contacter votre administrateur.";



                    toastr['error']( "Une erreur est survenue. Veuillez contacter votre administrateur.","<b></b>");

                } finally {
                    this.$store.dispatch('lancerchargement',false)
                    this.isSubmitting = false;
                }
            },




            async modifiermotdepasse_old(){

                if (/*this.Items.old==="" ||*/ this.Items.cfdp==="" || this.Items.newmdp==="" ){
                    toastr['error']( "Veuillez saisir toutes les informations.","<b></b>");
                    return
                }

                if (this.Items.cfdp!==this.Items.newmdp){
                    toastr['error']( "Le nouveau mot de passe ne sont pas identique.","<b></b>");
                    return
                }


                const t = this;


                t.$store.dispatch('lancerchargement',true)


                let url=process.env.VUE_APP_API_URL+'/login1478pojhgfderffg458755/password/'+this.$store.state.appsociete+'/'+randomString();
                let response =   axios  .post(url,this.Items,{
                    headers: {
                        'X-Requested-With': 'XMLHttpRequest',
                        'Accept': 'application/json',
                        'Content-Type': 'application/json',
                        'Authorization': 'Bearer ' + JwtService.getToken(),
                        'csrftoken': this.$store.state.appsociete
                    } ,withCredentials: true // Permet l'envoi de cookies et autres informations d'authentification
                })

                let res= await response
                    .then(function (res){

                        t.$store.dispatch('lancerchargement',false)
                        if(res.data.success){


                            JwtService.setAuthorization("")
                            t.$store.commit('userdata',{value:[]})
                            t.$store.commit('isAuthenticated',{value:false})
                            t.$store.commit('beartoken',{value:""})

                            JwtService.unsetTokenSociete()
                            JwtService.unsetToken()
                            JwtService.unsetTokenID()
                            JwtService.unsetTokenEXPIRESIN()


                            window.location.reload();


                        }
                        else{

                            let errormessage="";

                            t.messageerror="";
                            t.messagesucces="";
                            if (res.data.datamessage.length>0){

                                for (let message of res.data.datamessage){

                                    if (errormessage===""){

                                        errormessage=message;

                                    }else{

                                        errormessage+=" , "+message;

                                    }


                                }


                                t.messageerror=errormessage;

                            }
                            else{
                                t.messageerror=res.data.message
                            }


                            toastr['error'](t.messageerror,"<b></b>");

                            t.isdisplay=false;

                        }


                    })
                    .catch((error)=>{


                        }
                    )
                    .finally(() =>{




                    })


            },







            handleErrorResponse(responseData) {
                this.messageerror = "";

                if (responseData.datamessage && responseData.datamessage.length > 0) {
                    const errorMessage = responseData.datamessage.join(', ');
                    this.messageerror = errorMessage;

                    toastr['error']( errorMessage,"<b></b>");
                } else {
                    this.messageerror = responseData.message || "Une erreur est survenue lors de la modification.";

                    toastr['error']( this.messageerror,"<b></b>");
                }
            }
        }
    };
</script>

<style scoped>
    /* Charte cf-/ds- : tokens uniquement (light-only) */

    .mdp-container { max-width: 42rem; margin: 0 auto; }

    /* Champs charte (cf. fa2-*) */
    .fa2-inp { width:100%; height:40px; padding:0 12px; border-radius:0.25rem;
        border:1px solid rgb(var(--input-border,203 213 225)); background:#fff;
        color:var(--cf-ink); font-size:0.82rem; outline:none;
        transition:border-color .2s, box-shadow .2s; }
    .fa2-inp:focus { border-color:rgb(var(--primary)); box-shadow:0 0 0 3px rgb(var(--primary)/0.10); }
    .fa2-inp--error { border-color:rgb(var(--danger)); background:#fef2f2; }
    .mdp-inp { padding-right: 40px; height: 44px; }
    .fa2-label { font-size:0.72rem; text-transform:uppercase; letter-spacing:0.03em;
        font-weight:600; color:var(--cf-muted); display:flex; align-items:center; gap:4px;
        margin-bottom:0.35rem; }
    .fa2-req { color:rgb(var(--danger)); }
    .fa2-field-icon { position:absolute; top:50%; transform:translateY(-50%); left:0;
        padding-left:12px; display:flex; align-items:center; pointer-events:none;
        color:var(--cf-faint); font-size:1rem; z-index:1; }
    .fa2-err { display:flex; align-items:center; gap:0.3rem; font-size:0.72rem;
        color:rgb(var(--danger)); margin:4px 0 0; }

    /* Bouton œil (visibilité mot de passe) */
    .mdp-eye { position:absolute; right:10px; top:50%; transform:translateY(-50%);
        background:none; border:0; cursor:pointer; padding:4px;
        display:inline-flex; align-items:center; font-size:1.05rem; color:var(--cf-faint);
        transition:color .18s ease; }
    .mdp-eye:hover { color:var(--cf-ink); }

    /* Conseils de sécurité */
    .mdp-tips { margin-bottom: 1.25rem; }
    .mdp-tips__title { margin: 0 0 0.35rem; font-size: 0.88rem; font-weight: 700; }
    .mdp-tips__list { margin: 0; padding: 0; list-style: none; display: flex; flex-direction: column; gap: 0.3rem; }
    .mdp-tips__list li { display: flex; align-items: flex-start; gap: 0.35rem; }
    .mdp-tips__list i { flex-shrink: 0; margin-top: 0.1rem; }

    /* Messages succès / erreur */
    .mdp-msg { margin-bottom: 1rem; align-items: center; }
    .mdp-msg__txt { margin: 0; font-weight: 500; }
    .mdp-note-ok { background: #f0fdf4; border: 1px solid #bbf7d0; color: #15803d; }

    /* Carte formulaire */
    .mdp-card { padding: 1.5rem; }
    .mdp-form { display: flex; flex-direction: column; gap: 1.25rem; }

    /* Jauge de force */
    .mdp-meter { margin-top: 0.75rem; }
    .mdp-meter__head { display: flex; align-items: center; justify-content: space-between; margin-bottom: 4px; }
    .mdp-meter__label { font-size: 0.72rem; font-weight: 600; color: var(--cf-muted); }
    .mdp-meter__value { font-size: 0.72rem; font-weight: 600; }
    .mdp-meter__track { height: 8px; background: var(--cf-surface-alt); border-radius: 999px; overflow: hidden; }
    .mdp-meter__bar { height: 100%; transition: all 0.3s ease; }

    /* Exigences du mot de passe */
    .mdp-req-grid { margin-top: 0.5rem; display: grid; grid-template-columns: repeat(1, minmax(0, 1fr));
        gap: 0.35rem 0.75rem; font-size: 0.72rem; color: var(--cf-muted); }
    @media (min-width: 768px) { .mdp-req-grid { grid-template-columns: repeat(2, minmax(0, 1fr)); } }
    .mdp-req { display: flex; align-items: center; gap: 0.3rem; }
    .mdp-req--wide { grid-column: 1 / -1; }
    .mdp-ok  { color: #16a34a; }
    .mdp-ko  { color: #dc2626; }
    .mdp-off { color: var(--cf-faint); }

    /* Indicateur de correspondance */
    .mdp-match { margin-top: 0.5rem; display: flex; align-items: center; gap: 0.3rem; font-size: 0.8rem; }

    /* Actions du formulaire */
    .mdp-actions { padding-top: 1rem; border-top: 1px solid var(--cf-border);
        display: flex; flex-direction: column; gap: 0.75rem; }
    @media (min-width: 640px) { .mdp-actions { flex-direction: row; } }
    .mdp-submit { flex: 1; display: inline-flex; align-items: center; justify-content: center; gap: 0.4rem; }
    .mdp-submit:disabled { opacity: 0.5; cursor: not-allowed; }
    .mdp-spin { height: 1rem; width: 1rem; }

    /* Cartes d'information complémentaires */
    .mdp-info-grid { margin-top: 1.5rem; display: grid; grid-template-columns: repeat(1, minmax(0, 1fr)); gap: 1rem; }
    @media (min-width: 768px) { .mdp-info-grid { grid-template-columns: repeat(2, minmax(0, 1fr)); } }
    .mdp-info__txt { margin: 0; font-size: 0.82rem; color: var(--cf-muted); line-height: 1.5; }

    /* Animations */
    @keyframes mdpFadeIn {
        from { opacity: 0; transform: translateY(-10px); }
        to { opacity: 1; transform: translateY(0); }
    }
    .mdp-tips, .mdp-card, .mdp-info-grid > .cf-card { animation: mdpFadeIn 0.3s ease-out; }
    .mdp-info-grid > .cf-card:nth-child(2) { animation-delay: 0.1s; }

    @keyframes spin {
        0% { transform: rotate(0deg); }
        100% { transform: rotate(360deg); }
    }
    .animate-spin { animation: spin 1s linear infinite; }
</style>
